import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  connect() {
    // Validation responses replace the field first, then subsequent coupon GETs
    // must preserve the corrected input again.
    this.element.dataset.turboPermanent = "true";
  }

  clearPhoneError() {
    // The server error describes the previous value; validate the new value on submit.
    this.element.querySelectorAll(".form-error-message").forEach(error => error.remove());
    this.element.querySelectorAll(".field_with_errors").forEach(field => {
      field.replaceWith(...field.childNodes);
    });
  }
}
